import AppRoute from './AppRoute';
import {lazy} from 'react';
import {userHasFeaturePermission} from "../Core/util";

// @ts-ignore
const routes: AppRoute[] = [
    {
        path: '/dataflow',
        component: lazy(() => import('../../casmon/DataFlowGraph/DataFlowContainer')),
        title: 'casmon:routes.overview',
        icon: 'sitemap'
    },
    {
        path: '/data/reporting/custom',
        component: lazy(() => import('../../casmon/Reporting/Custom/Usage/CustomReportOverviewContainer')),
        title: 'casmon:routes.custom_reporting',
        hideInNav: true,
        icon: 'paper plane'
    },
    {
        path: '/data/reporting/overview',
        component: lazy(() => import('../../casmon/Reporting/overview/ProcessOverviewReport/ProcessOverviewReport')),
        title: 'casmon:routes.reporting_overview',
        hideInNav: true,
        icon: 'table',
    },
    {
        path: '/data/reporting',
        component: lazy(() => import('../../casmon/Reporting/ReportRootPage/ReportRootPage')),
        title: 'casmon:routes.reporting_root_page',
        icon: 'table',
        subRoutes: [

            {
                path: '/data/reporting/overview',
                component: lazy(() => import('../../casmon/Reporting/overview/ProcessOverviewReport/ProcessOverviewReport')),
                title: 'casmon:routes.reporting_overview',
                icon: 'table',
            },
            {
                path: '/data/reporting/custom',
                component: lazy(() => import('../../casmon/Reporting/Custom/Usage/CustomReportOverviewContainer')),
                title: 'casmon:routes.custom_reporting',
                icon: 'paper plane'
            }
        ]
    },
    {
        path: '/data/event',
        component: lazy(() => import('../../casmon/Events/Components/ProcessOverview/ProcessOverview')),
        title: 'casmon:routes.events',
        icon: 'table'
    },
    {
        path: '/data/reprocessing',
        component: lazy(() => import('../../casmon/Reprocessing/ReprocessingOverview')),
        title: 'casmon:routes.reprocessing',
        icon: 'repeat'
    },
    {
        path: '/file',
        component: lazy(() => import('../../modules/Files/FileManagerRootPage')),
        title: 'casmon:routes.files',
        icon: 'file'
    },
    {
        path: '/configuration/data/integrationprocess',
        component: lazy(() => import('../DataQuality/containers/DataQualityContainer')),
        title: 'casmon:routes.integration',
        icon: 'hubspot',
        hideInNav: true,
        disabled: () => !userHasFeaturePermission("settings-integration")
    },
    {
        path: '/configuration/data/system',
        component: lazy(() => import('../DataQuality/containers/DataQualityContainer')),
        title: 'casmon:routes.systems',
        icon: 'server',
        hideInNav: true,
        disabled: () => !userHasFeaturePermission("settings-systems")
    },
    {
        path: '/configuration/data/alertingMail',
        component: lazy(() => import('../DataQuality/containers/DataQualityContainer')),
        title: 'casmon:routes.alerting_mail',
        icon: 'alarm',
        hideInNav: true,
        disabled: () => !userHasFeaturePermission("settings-alertingMail")
    },
    {
        path: '/configuration/data/AlertingMailTemplate',
        component: lazy(() => import('../DataQuality/containers/DataQualityContainer')),
        title: 'casmon:routes.mail_template',
        icon: 'file code',
        hideInNav: true,
        disabled: () => !userHasFeaturePermission("settings-AlertingMailTemplate")
    },
    {
        path: '/configuration/data/customreports',
        component: lazy(() => import('../../casmon/Reporting/Custom/Configuration/CustomReportConfigContainer')),
        title: 'casmon:routes.custom_reporting',
        icon: 'edit outline',
        hideInNav: true,
        disabled: () => !userHasFeaturePermission("settings-CustomReport")
    },
    {
        path: '/data',
        component: lazy(() => import('../DataQuality/containers/DataQualityContainer')),
        title: 'casmon:routes.data',
        icon: 'table',
        hideInNav: true
    },
    {
        path: '/user',
       /* component: lazy(() => import('../Settings/UserManagement/Users/UserSettingsPage')), */
        component: lazy(() => import('../UserSettings/UserProfilePage')),
        title: 'casmon:routes.user',
        icon: 'user',
        hideInNav: true
    },
    {
        path: '/settings/entities',
        component: lazy(() => import('../Settings/EntityTypes/List/EntitiesContainer')),
        title: 'casmon:routes.entities',
        icon: 'database',
        hideInNav: true,
        disabled: () => !userHasFeaturePermission("settings-entity")
    },
    {
        path: '/settings/access-control',
        component: lazy(() => import('../Settings/UserManagement/AccessControlRootPage')),
        title: 'casmon:routes.access_control',
        icon: 'privacy',
        hideInNav: true,
        disabled: () => !userHasFeaturePermission("settings-access-control")
    },
    {
        path: '/settings/environment',
        component: lazy(() => import('../Settings/SystemSettings/EnvironmentSettingsPage')),
        title: 'casmon:routes.environment',
        icon: 'server',
        hideInNav: true,
        disabled: () => !userHasFeaturePermission("settings-environment")
    },
    {
        path: '/settings/buckets',
        component: lazy(() => import('../Settings/BucketSettings/BucketSettingsRootPage')),
        title: 'Buckets',
        icon: 'file',
        hideInNav: true,
        disabled: () => !userHasFeaturePermission("settings-buckets")
    },
    {
        path: '/settings/mail',
        component: lazy(() => import('../Settings/Mail/MailSettingsRootPage')),
        title: 'E-Mail',
        icon: 'mail',
        hideInNav: true,
        disabled: () => !userHasFeaturePermission("settings-mail")
    },
    {
        path: '/settings/config',
        component: lazy(() => import('../Settings/Configuration/ConfigSettingsRootPage')),
        title: 'casmon:routes.features_configuration',
        icon: 'configure',
        hideInNav: true,
        disabled: () => !userHasFeaturePermission("settings-config")
    },
    {
        path: '/configuration',
        component: lazy(() => import('../DataQuality/containers/DataQualityRootPage')),
        title: 'casmon:routes.configuration',
        icon: 'configure',
        requiredRole: 'ROLE_ACTUATOR', disabled: () => !userHasFeaturePermission("configuration"),
        subRoutes: [
            {
                path: '/configuration/data/integrationprocess',
                title: 'casmon:routes.integration',
                icon: 'hubspot',
                disabled: () => !userHasFeaturePermission("configuration-integration")
            },
            {
                path: '/configuration/data/system',
                title: 'casmon:routes.systems',
                icon: 'server',
                disabled: () => !userHasFeaturePermission("configuration-systems")
            },
            {
                path: '/configuration/data/alertingMail',
                title: 'casmon:routes.alerting_mail',
                icon: 'alarm',
                disabled: () => !userHasFeaturePermission("configuration-alertingMail")
            },
            {
                path: '/configuration/data/AlertingMailTemplate',
                title: 'casmon:routes.mail_template',
                icon: 'file code',
                disabled: () => !userHasFeaturePermission("configuration-AlertingMailTemplate")
            },
            {
                path: '/configuration/data/customreports',
                title: 'casmon:routes.custom_reporting',
                icon: 'record',
                disabled: () => !userHasFeaturePermission("configuration-CustomReport")
            }
        ]
    },
    {
        path: '/settings',
        component: lazy(() => import('../Settings/SystemSettings/SystemSettingsRootPage')),
        title: 'casmon:routes.settings',
        icon: 'settings',
        requiredRole: 'ROLE_ACTUATOR',
        disabled: () => !userHasFeaturePermission("settings"),
        subRoutes: [
            {
                path: '/settings/access-control',
                title: 'casmon:routes.access_control',
                icon: 'privacy',
                disabled: () => !userHasFeaturePermission("settings-access-control")
            },
            {
                path: '/settings/buckets',
                title: 'Buckets',
                icon: 'file',
                disabled: () => !userHasFeaturePermission("settings-bucket")
            },
            {
                path: '/settings/environment',
                title: 'casmon:routes.environment',
                icon: 'server',
                disabled: () => !userHasFeaturePermission("settings-environment")
            },
            {
                path: '/settings/mail',
                title: 'E-Mail',
                icon: 'mail',
                disabled: () => !userHasFeaturePermission("settings-mail")
            },
            {
                path: '/settings/config',
                title: 'casmon:routes.features_configuration',
                icon: 'configure',
                disabled: () => !userHasFeaturePermission("settings-config")
            }
        ]
    }
];

export default routes;
